export function normalizeOptionValues(current: unknown): string[] {
  if (Array.isArray(current)) {
    return current.filter((value): value is string => typeof value === "string");
  }
  if (typeof current === "string" && current.length > 0) {
    return [current];
  }
  return [];
}

export function toggleOptionValue({
  current,
  value,
  multiple,
  max,
}: {
  current: unknown;
  value: string;
  multiple?: boolean;
  max?: number;
}): { next: string | string[]; error?: string } {
  const selected = normalizeOptionValues(current);

  if (multiple) {
    if (selected.includes(value)) {
      return { next: selected.filter((item) => item !== value) };
    }
    if (typeof max === "number" && selected.length >= max) {
      return {
        next: selected,
        error: `Puoi selezionare al massimo ${max} opzioni`,
      };
    }
    return { next: [...selected, value] };
  }

  if (selected.includes(value)) {
    return { next: "" };
  }
  return { next: value };
}
